import { MapAddressRequestModel } from '../../models/map/map';

export class Geocode {
    static readonly type = '[Map] Geocode';
    constructor() { }
}

export class GetLocation {
  static readonly type = '[Map] GetLocation';
  constructor(public Location: MapAddressRequestModel) { }
}
